import React from 'react';
import { FileText, CircleCheck, TriangleAlert, CircleX, DollarSign } from 'lucide-react';
import { StatCard, MetricRow } from '../../common';
import { formatNumber, formatCurrency } from '../../../utils/format';
import { useContractStats } from './contractElements.controller';

/**
 * KPIs del listado. El total invertido (y sus conteos) responde a los filtros aplicados en la
 * pantalla; los conteos de estado se calculan sobre las filas visibles.
 */
export default function ContractAnalytics({ contracts, investment }) {
    const analytics = useContractStats(contracts);

    const statusCards = (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-2">
            <StatCard
                label="Total Contrataciones"
                value={formatNumber(analytics.totalContracts)}
                icon={<FileText />}
                tone="brand"
                hint="Contrataciones registradas"
            />
            <StatCard label="Activas" value={formatNumber(analytics.activeContracts)} icon={<CircleCheck />} tone="success" hint="Contrataciones vigentes" />
            <StatCard label="Expiradas" value={formatNumber(analytics.expiredContracts)} icon={<TriangleAlert />} tone="warning" hint="Requieren renovación" />
            <StatCard label="Inactivas" value={formatNumber(analytics.inactiveContracts)} icon={<CircleX />} tone="danger" hint="Contrataciones pausadas" />
        </div>
    );

    if (!investment) return statusCards;

    return (
        <div className="grid gap-4 grid-cols-1 lg:grid-cols-3">
            {/* Total invertido según los filtros aplicados en la pantalla */}
            <StatCard
                label="Total Invertido"
                value={formatCurrency(investment?.total || 0)}
                icon={<DollarSign />}
                tone="success"
                hint={investment?.isFiltered ? 'Según los filtros aplicados' : 'Todas las contrataciones'}
                footer={
                    <>
                        <MetricRow label="Contrataciones" value={formatNumber(investment?.contractsCount || 0)} />
                        <MetricRow label="Pisos de venta" value={formatNumber(investment?.storesCount || 0)} />
                    </>
                }
            />
            <div className="lg:col-span-2">{statusCards}</div>
        </div>
    );
}
